<template>
    <div
        class="timeline_item"
        :class="{ timeline_item_inverted: !pullLeft || asPreview }"
    >
        <div
            class="timeline_item_container"
            :class="{ asPreview }"
        >
            <div class="timeline_item_content animated fadeIn">
                <slot name="content"></slot>
            </div>
            <slot name="icon">
                <kgr-timeline-item-icon />
            </slot>
        </div>
    </div>
</template>

<script>
import TimelineItemIcon from './TimelineItemIcon.vue';

export default {
    components: {
        'kgr-timeline-item-icon': TimelineItemIcon,
    },
    props: {
        pullLeft: {
            type: Boolean,
            required: false,
            default: false,
        },
        asPreview: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .timeline_item {
    margin-bottom: 32px;
    padding: 10px;
    text-align: right;
    .timeline_item_container {
        width: calc(50% + 24px);
        display: flex;
        align-items: center;
        .timeline_item_content {
            flex: 1 0 auto;
            position: relative;
            margin-left: 0;
            margin-right: 32px;
        }
        &.asPreview {
            width: auto;
        }
    }
    &.timeline_item_inverted {
        text-align: left;
        .timeline_item_container {
            margin-left: calc(50% - 24px);
            flex-direction: row-reverse;
            .timeline_item_content {
                border-radius: 0 4px 4px 4px;
                margin-left: 32px;
                margin-right: 0;
            }
            &.asPreview {
                margin-left: auto;
            }
        }
    }
}
</style>
